import React from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

export default function SearchBar({ value, onChange }) {
  return (
    <Input
      placeholder="Buscar productos..."
      prefix={<SearchOutlined style={{ color: "rgba(0,0,0,0.35)" }} />}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      size="large"
      allowClear
      style={{ marginBottom: 16 }}
    />
  );
}
